/**
 * Shared room-state → route mapping.
 *
 * Mirrors `screenForState` in the app's `components/Mediation/roomRouting.ts`.
 *
 * This exists for the screens that WATCH the room doc and carry the user
 * forward on a live state change — the waiting room and the opener. They each
 * hand-rolled that as `state !== 'prep'` plus a hardcoded destination, and that
 * test is the bug this module prevents: `ended` also satisfies `!== 'prep'`.
 * A room ended while you sat in the waiting room therefore pushed you onto the
 * opener's "f8 is preparing the synthesis…" spinner, which never resolves —
 * no synthesis is coming for a dead room.
 *
 * `invited` and `prep` are deliberately absent: they have no single answer
 * (they depend on role, and on whose rules are saved). The list's own
 * `routeFor` owns those.
 */

import type { RoomState } from '../types/room';

export function pathForState(mediationId: string, state: RoomState): string {
  switch (state) {
    case 'rules_set':
    case 'joint':
      return `/rooms/${mediationId}/opener`;
    case 'ongoing':
    case 'paused':
      return `/rooms/${mediationId}/room`;
    case 'ended':
      return `/rooms/${mediationId}/summary`;
    default:
      return '/rooms';
  }
}
